import { fetchViaPost } from './fetchViaPost';

export async function readWorkflowResponse(response, {allowBatchFailure = false} = {}) {
  let body;
  try { body = await response.json(); } catch { throw new Error(`Invalid server response (HTTP ${response.status})`); }
  const batchFailure = allowBatchFailure && body?.code === "COMPILATION_PARTIAL_FAILURE" && Array.isArray(body.result);
  if (!response.ok || !body || (body.success === false && !batchFailure) || body.error) {
    throw new Error(body?.message || body?.code || body?.error || `HTTP ${response.status}`);
  }
  return body;
}

export async function saveTeamSettingsVerified(strengths) {
  const saved = await readWorkflowResponse(await fetchViaPost('put-team-strengths', JSON.stringify(strengths)));
  if (saved.success !== true) throw new Error('TEAM_SETTINGS_SAVE_NOT_CONFIRMED');
  const reloaded = await readWorkflowResponse(await fetchViaPost('get-team-strengths', JSON.stringify({
    season_id:strengths[0].season_id, team_ids:strengths.map(team=>team.team_id),
  })));
  for (const team of strengths) {
    const actual = reloaded[team.team_id];
    for (const [field,value] of Object.entries(team)) {
      if (field === 'user_id') continue;
      if (!actual || (JSON.stringify(actual[field]) !== JSON.stringify(value) &&
          !(typeof actual[field] !== 'object' && value !== null && value !== '' &&
            Number.isFinite(Number(value)) && Number(actual[field]) === Number(value))))
        throw new Error(`TEAM_SETTINGS_READBACK_MISMATCH: ${team.team_id}/${field}`);
    }
  }
  return reloaded;
}

export function compileBatchOutcome(body, requestedIds) {
  const results = Array.isArray(body?.result) ? body.result : [];
  const failed = [], succeeded = [];
  requestedIds.forEach(id => {
    const result = results.find(item => Number(item?.fixture_id ?? item?.id ?? item?.detail?.id) === Number(id));
    if (!result || result.success === false || result.error) failed.push(Number(id));
    else succeeded.push(Number(id));
  });
  return { failed, succeeded, details:results.filter(item=>item?.success !== false && !item?.error && item?.detail).map(item=>item.detail) };
}
